import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function AccessControlTarget ( props ) {

    return <BasicCrudScreenType id="AccessControlTarget" table="AccessControlTarget" view="AccessControlTarget" />

}

export default AccessControlTarget;
